import { graphql } from 'react-relay';

import { AlimTalkTaskWindowPaginator_query$key } from '../../../relay/__generated__/AlimTalkTaskWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const AlimTalkTaskWindowPaginator_query = graphql`
  fragment AlimTalkTaskWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: AlimTalkTaskFilter }
    order: { type: AlimTalkTaskOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "AlimTalkTaskWindowPaginatorRefreshQuery") {
    alimTalkTasks(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...AlimTalkTaskConnectionDataTable_alimTalkTaskConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<AlimTalkTaskWindowPaginator_query$key>, 'fragment'>;

const AlimTalkTaskWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={AlimTalkTaskWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (paginationProps) => (
          <Pagination {...paginationProps} pages={data.alimTalkTasks.pages} loadPage={loadPage} />
        ),
      })
    }
  </FragmentWindowPaginator>
);

export default AlimTalkTaskWindowPaginator;
